// Link: http://reactcommunity.org/react-modal/#installation
import React, { Component } from "react";
import ReactModal from "react-modal";
import PropTypes from "prop-types";

class Modal extends Component {
  customStyles = {
    content: {
      width: this.props.width || "30%",
      height: this.props.height || "50%",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: this.props.padding || "0",
      margin: this.props.margin || "0",
      overflow: this.props.overflow || "auto"
    }
  };

  render() {
    return (
      <ReactModal ariaHideApp={false} style={this.customStyles} {...this.props}>
        {this.props.children}
      </ReactModal>
    );
  }
}

Modal.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  children: PropTypes.any
};

export default Modal;
